import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function Login() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => { if (!loading && user) navigate("/dashboard"); }, [user, loading, navigate]);

  const startGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#F6F3EC] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center mb-8"><Logo variant="dark" to={null} /></div>

        <div className="bg-white border border-[#E5E5E5] rounded-sm p-6">
          <h1 className="font-display text-xl font-bold tracking-tight text-center mb-1">Sign in to FIAD</h1>
          <p className="text-sm text-[#525252] text-center mb-6">Continue with your Google account to apply and access your expert dashboard.</p>
          <button data-testid="google-login-btn" onClick={startGoogle} className="w-full flex items-center justify-center gap-3 bg-white text-[#0A0A0A] border border-[#0A0A0A] px-5 py-3 rounded-sm text-sm font-medium hover:bg-[#F5F5F5] transition-colors">
            <svg className="h-4 w-4" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/><path fill="#EA4335" d="M12 4.75c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 1.46 14.97.5 12 .5A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 6.68 9.14 4.75 12 4.75z"/></svg>
            Continue with Google
          </button>
        </div>
        <button onClick={() => navigate("/")} className="mt-6 w-full text-sm text-[#525252] hover:text-[#0A0A0A]">← Back to home</button>
      </div>
    </div>
  );
}
